// Qué campos están tocados y sin guardar, POR SU NOMBRE (lienzo, tablero «Cambios sin guardar»).
//
// «2 cambios sin guardar» obliga a repasar la pantalla entera para encontrarlos; «2 cambios sin
// guardar · Fecha objetivo, Prioridad» no obliga a nada. Es el mismo criterio que ya rige el aviso
// de conflicto, que enumera los campos que cambió el otro usuario en vez de decir cuántos.
//
// ⚠️⚠️ LA PROPIEDAD QUE SOSTIENE TODO ESTO: LA LISTA NOMBRA **TODOS** LOS CAMBIOS CONTADOS. Un campo
// sin rótulo conocido NO se descarta — se nombra con su identificador. Si se cayera de la lista, el
// contador y los nombres dirían cosas distintas («2 cambios · Fecha objetivo») y quien lo lea se
// quedará buscando el segundo, que es peor que no haber nombrado ninguno. Y el caso no es teórico:
// las columnas extendidas las define cada instalación.
//
// La traducción la pone quien pinta, que es quien tiene el `t_` — igual que `orderAttention`.

// Los campos editables fijos del bloque General, por el nombre con el que viajan en el lote. Los
// rótulos son LOS MISMOS literales que pinta cada fila: si alguien renombra un campo en la ficha y
// se olvida de aquí, la barra lo llamará distinto que su propia etiqueta.
export const GENERAL_FIELD_LABEL_KEYS = {
  targetDate: 'Target date',
  deliveryDate: 'Delivery date',
  minStartDate: 'Min start date',
  priority: 'Priority',
  planType: 'Fabrication order plan type',
  client: 'Client',
  parentFo: 'Parent FO',
  forecast: 'Forecast',
  expirationDate: 'Forecast expiration date'
}

/**
 * Los campos tocados, en el orden en que se tocaron.
 *
 * @param {object} pending el lote de cambios sin guardar (`useUnsavedChanges().pending`)
 * @param {Array<{field: string, name: string}>} extendedColumns las columnas extendidas de esta
 *   instalación, cuyo nombre es un DATO y no un literal traducible
 * @returns {Array<{field: string, labelKey: string, label: string}>} `labelKey` para traducir;
 *   `label` ya resuelto cuando el nombre viene del dato. Nunca los dos vacíos a la vez.
 */
// Sun names a field in a conflict (`extendedColumn3`, `fabricationOrderPlanTypeCode`) the way the
// save body does, not the way the batch does (`extended_column3`, `planType`).
const canonicalField = (field) => {
  if (field === 'fabricationOrderPlanTypeCode') return 'planType'
  return /^extended_?column\d+$/i.test(field) ? field.replace(/^extended_?column/i, 'extended_column') : field
}

export const changedFieldLabels = (pending, extendedColumns = []) => {
  const columnas = new Map((extendedColumns || []).map((column) => [column.field, column.name]))
  return Object.keys(pending || {}).map((field) => {
    const known = canonicalField(field)
    if (GENERAL_FIELD_LABEL_KEYS[known]) {
      return { field, labelKey: GENERAL_FIELD_LABEL_KEYS[known], label: '' }
    }
    // El nombre de una columna extendida lo pone la instalación: ya viene escrito, no se traduce.
    // Y si la columna no está en la lista —o el campo es uno que nadie ha rotulado— se cae al
    // identificador antes que a nada: ver `extended_column3` es feo, no encontrarlo es peor.
    return { field, labelKey: '', label: columnas.get(known) || field }
  })
}
